import { createContext, useState } from 'react'

const AppContext = createContext({
  listOpenMapIds: [],
  setListOpenMapIds: function (any) { }
})

export function AppContextProvider(props) {
  const [listOpenMapIds, setListOpenMapIds] = useState([]);

  const context = {
    listOpenMapIds: listOpenMapIds,
    setListOpenMapIds: setListOpenMapIds
  }

  return (
    <AppContext.Provider value={context}>
      {props.children}
    </AppContext.Provider>
  )
}

export default AppContext
